import ForcedDialog from 'Components/ForcedDialog/ForcedDialog'
import PTASelect from 'Components/PTASelect'
import {
  getSelectedPta,
  isPtaSelectionVisible
} from 'Services/common/Features/Authority/Context/utils'
import useTypedSelector from 'Store'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Box, Button, DialogContent, DialogTitle } from '@mui/material'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { t } from 'ttag'

interface AuthoritySelectionRequiredProps {
  backButtonFallbackPath: string
}

function AuthoritySelectionRequired({
  backButtonFallbackPath
}: Readonly<AuthoritySelectionRequiredProps>) {
  const { user } = useTypedSelector(state => state.user)
  const location = useLocation()
  const navigate = useNavigate()
  const isAuthoritySelectionRequired =
    isPtaSelectionVisible(user, location) && getSelectedPta() === ''
  const previousLocation = usePreviousLocation(backButtonFallbackPath)

  return (
    <>
      <Outlet />
      <ForcedDialog open={isAuthoritySelectionRequired}>
        <Box sx={{ px: 3, pt: 2 }}>
          <Button
            size="small"
            sx={theme => ({ color: theme.palette.text.primary })}
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(previousLocation)}
          >
            {t`Back`}
          </Button>
        </Box>
        <DialogTitle variant="h3">{t`Please select an authority to continue`}</DialogTitle>
        <DialogContent sx={{ pb: 4 }}>
          <PTASelect />
        </DialogContent>
      </ForcedDialog>
    </>
  )
}

export default AuthoritySelectionRequired
